
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/managed-transportation-master-services-agreement",
      function () {
        return require("private-next-pages/managed-transportation-master-services-agreement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/managed-transportation-master-services-agreement"])
      });
    }
  